<template>
  <transition name="fade">
    <div v-if="shouldShowSavings" class="pd-Savings_Wrapper">
      <div class="pd-Show_SalesPercent h5 mb-0">-{{ savings }} %</div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ProductSavingsBadge",
  props: {
    minChange: {
      required: true,
      type: Number,
    },
  },
  computed: {
    ...mapGetters({
      chosenVariant: "variantPicker/chosenVariant",
      allProductVariants: "variantPicker/allProductVariants",
    }),
    savings() {
      if (this.variant && this.variant.price_crossed) {
        return this.calculateSavings(this.variant.price, this.variant.price_crossed);
      }
      return null;
    },
    shouldShowSavings() {
      return this.savings > this.minChange;
    },
    variant() {
      return this.allProductVariants.find(variant => variant.id === this.chosenVariant);
    },
  },
  methods: {
    calculateSavings(price, crossPrice) {
      if (price <= crossPrice && crossPrice !== 0) {
        return Math.round(((crossPrice - price) / crossPrice) * 100);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.pd-Show_SalesPercent {
  display: flex;
  align-items: center;
  justify-content: center;
  width: $width-product-savings-badge-sm;
  height: $width-product-savings-badge-sm;
  font-size: $h5-font-size;
  border-radius: $width-product-savings-badge-sm $width-product-savings-badge-sm
    $width-product-savings-badge-sm $border-radius-lg;

  @media (min-width: $screen-md-min) {
    border-radius: $width-product-savings-badge $width-product-savings-badge
      $width-product-savings-badge $border-radius-lg;
    width: $width-product-savings-badge;
    height: $width-product-savings-badge;
    font-size: $h4-font-size;
  }
}

.pd-Savings_Wrapper {
  z-index: $zi-lowest;
  position: absolute;
  top: $spacer / 4;
  right: $spacer / 4;

  @media (min-width: $screen-md-min) {
    top: -$spacer / 4;
    right: -$spacer / 4;
  }

  @media (min-width: $screen-md-min) {
    top: -$spacer / 2;
    right: -$spacer / 2;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity $transition-duration;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
